import { openaiAPI } from 'appState/initialStateAssistant';

export async function fetchAIVision({image_url,message="Summarise this image and provide an analysis of it from a personal financial perspective. Don't include the word image in your answer."}) {
    const response = await openaiAPI.chat.completions.create({
        model: "gpt-4o-mini",
        messages: [
          {
            role: "developer",
            content: [
              { type: "text", text: "You are a financial advisor. You are given an image of a financial document. You need to summarise the document and provide an analysis of it from a personal financial perspective. Don't include the word image in your answer." },
            ],
          },
          {
            role: "user",
            content: [
              { type: "text", text: message },
              {
                type: "image_url",
                image_url: {
                  "url": image_url,
                  "detail": "high"
                },
              },
            ],
          },
        ],
      });
      return response.choices[0];
}
